module.exports = __webpack_public_path__ + "img/vogu.ef351fb2.webp";